import {SET_I18N, SET_I18N_LANGUAGE} from "../services/constants"

const module = {
  state: {
    i18n: {},
  },
  getters: {

  },
  mutations: {
    [SET_I18N](state, payload){
      state.i18n = payload
    },
    [SET_I18N_LANGUAGE](state, payload){
      state.i18n.locale = payload
    },
  },
}

export default module
export const i18nModule = module
